import React from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../../components/atoms/const';
import api from '../../../../components/api';

function useAddAisle(id: number | undefined, refetch: () => any, isUpdate: boolean) {
  const [result, setResult] = React.useState<any>();
  const { mutate: addAisle, isLoading: addLoad } = useMutation(api.warehouse.addAisle, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      setResult(data);
      refetch();
    },
    onError: (error) => {
      console.log(error);
      setResult(error);
    },
  });

  const { mutate: updateAisle, isLoading: updateLoad } = useMutation(api.warehouse.updateAisle, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log(data);
      setResult(data);
      refetch();
    },
    onError: (error) => {
      console.log(error);
      setResult(error);
    },
  });

  const yupSchemaAdd = yup.object({
    name: yup.string().required(yupErrorMsg.AISLE_NAME_EMPTY),
    level: yup.number().min(0, yupErrorMsg.LEVEL_POSITIVE).required(yupErrorMsg.LEVEL_EMPTY),
  });

  const yupSchemaUpdate = yup.object({
    newName: yup.string().required(yupErrorMsg.AISLE_NEW_NAME_EMPTY),
  });

  const formik = useFormik({
    initialValues: !isUpdate ? {
      name: '',
      level: 0,
    } : {
      name: '',
      newName: '',
    },
    validationSchema: !isUpdate ? yupSchemaAdd : yupSchemaUpdate,
    onSubmit: (values) => {
      if (id) {
        if (!isUpdate) {
          addAisle({
            warehouseId: id,
            name: values.name,
            level: values.level!,
          });
        } else {
          updateAisle({
            warehouseId: id,
            name: values.name,
            newName: values.newName!,
          });
        }
      }
    },
  });

  const afterSubmit = () => {
    setResult(undefined);
    refetch();
  };

  return {
    formik,
    modal: {
      result,
      afterSubmit,
      load: addLoad || updateLoad,
    },
  };
}

export default useAddAisle;
